import { Validator } from 'fluentvalidation-ts';
import { ReceivedMeals } from '@/models';
import moment from 'moment';

export class ReceivedMealsHardValidator extends Validator<ReceivedMeals> {
  constructor() {
    super();

    this.ruleFor('mealCountReceived')
      .greaterThanOrEqualTo(0);

    this.ruleFor('mealCountLeftoverPrevious')
      .greaterThanOrEqualTo(0);

    this.ruleFor('mealDeliveryDateTime')
      .notEmpty()
      .must((v, m) => {
        const date = moment(v, moment.defaultFormatUtc);
        const current = moment().add(30, 's');
        return date < current;
      })
      .withMessage('Invalid Meal Count: Meal Received Time cannot be a future date or time.');
  }
}
